module.exports = __webpack_public_path__ + "static/img/logo_015.09a682bb.png";